module.exports = {
    "en": {
        "resetPassword": {
            "header": "Reset Password",
            "subHeader": "Please enter your new password.",
            "submit": "Submit",
            "authenticationError": "The information you have provided is incorrect.",
            "unknownServerError": "Unable to process request.",
            "successMessage": "Your password has been successfully updated.<br>You should be redirected back to your product soon. If not please navigate back to your chosen product."
        },
        "invalidToken": {
            "invalidTokenHeader": "Your link has expired",
            "invalidTokenHeaderPara": "The link you have clicked on has expired. Please enter your e-mail address to receive a new link.",
            "resetPasswordHeader": "Reset Password",
            "resetPasswordHeaderPara": "Please enter your e-mail address so that we can send you a link to reset your password.",
            "emailPlaceholder": "E-mail Address",
            "submit": "Submit",
            "invalidEmailError": "Your e-mail address is improperly formatted.",
            "emptyEmail": "Please enter a valid email address.",
            "unknownServerError": "We’re having some issues sending your password reset e-mail. Sorry about that, but we are working on resolving the issue. Please wait a few minutes and then click \"Submit\" again.",
            "noTokenSuccess": "If an account matches the address you provided, we will send you an email with instructions on how to create a new password.",
            "invalidTokenSuccess": "A new link was sent to your e-mail address."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Your password must:",
                "policies": [
                    {
                        "policy": "Be at least 8 characters long"
                    },
                    {
                        "policy": "Contain at least one alpha(A-Z) character, and one number or symbol"
                    },
                    {
                        "policy": "NOT contain 4 or more sequential or repeating characters (e.g. AAAA or 1234)"
                    },
                    {
                        "policy": "NOT contain your username, \"mstar\", \"MStar\", or \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "New Password",
            "emptyPassword": "Please enter a valid password.",
            "required": "The password does not meet requirements.",
            "maxLength": "Password has exceeded the maximum length allowed.",
            "passwordConfirmationPlaceholder": "Verify New Password",
            "passwordMatch": "Passwords don't match.",
            "ie789Password": "Password",
            "ie789PasswordVerify": "Verify Password"
        },
        "login": {
            "ie789Email": "E-mail Address",
            "emailPlaceholder": "E-mail Address",
            "ie789Password": "Password",
            "passwordPlaceholder": "Password",
            "signin": "Sign In",
            "invalidEmailError": "Your e-mail address is improperly formatted.",
            "emptyEmail": "Please enter a valid email address.",
            "authenticationError": "The information you have provided is incorrect.",
            "unknownServerError": "Unable to process request.",
            "maxlength": "The information you have provided is incorrect.<br>Please correct the fields and try again.",
            "required": "The information you have provided is incomplete.<br>Please fully complete both fields before submission.",
            "rememberMe": "Keep me signed in",
            "forgotPassword": "Forgot your password?",
            "notAMember": "Not a Member?"
        },
        "enterMFA": {
            "mfaHeader": "OK great, enter your code here.",
            "IdentificationPlaceholder": "Identification Code",
            "badToken": "That code is either inaccurate or has expired.",
            "cancel": "Cancel",
            "go": "Go",
            "newCode": "Need a new Code?",
            "resend": "Resend.",
            "emailMeHint": "We sent you a code to the e-mail address ",
            "emailExpire": "It expires after 30 minutes.",
            "textMeHint": "We sent you a code to phone number ",
            "textExpire": "It expires after 30 minutes."
        },
        "receiveMFA": {
            "receiveMFAHeader": "For added security we're going to ask you to enter a verification code.",
            "receiveMFAHeaderPara": "You can expect to do this every 30 days on each device you use to access this product.",
            "cancel": "Cancel",
            "emailMe": "Email Me",
            "textMe": "Text Me",
            "emailTextInform": "We're having some issues sending the validation. Sorry about that, but we are working on resolving the issue. You can request the code be sent through an alternate method, or you can retry your e-mail request in a few minutes.",
            "emailInform": "We're having some issues sending the validation. Sorry about that, but we are working on resolving the issue. Please retry your e-mail request in a few minutes.",
            "emailHint": "Do you want to validate with e-mail address ",
            "textHint": "or phone number ",
            "emailMeHint": "A validation code will be sent to your e-mail address ",
            "textMeHint": "A validation code will be sent to your phone number "
        },
        "forgotPwd": {
            "forgotPara": "Please provide us with your registered e-mail address and we will send you an e-mail with instructions on how to create a new password",
            "emailPlaceholder": "E-mail Address",
            "invalidEmail": "Your e-mail address is improperly formatted.",
            "emptyEmail": "Please enter a valid email address.",
            "submit": "Submit",
            "cancel": "Cancel",
            "unknownServerError": "We’re having some issues sending your password reset e-mail. Sorry about that, but we are working on resolving the issue. Please wait a few minutes and then click \"Submit\" again.",
            "forgotPasswordSuccess": "If an account matches the address you provided, we will send you an email with instructions on how to create a new password.",
            "returnToLogin": "Return to Login"
        }
    },
    "fc": {
        "resetPassword": {
            "header": "Réinitialisez votre mot de passe",
            "subHeader": "Veuillez entrer votre mot de passe.",
            "submit": "Soumettre",
            "authenticationError": "Les informations que vous avez fournies sont incorrectes.",
            "unknownServerError": "Il est impossible de traiter votre demande.",
            "successMessage": "Votre mot de passe a été mis à jour.<br>Vous devriez être redirigé vers votre produit bientôt. Si ce n'est pas le cas, retournez au produit choisi."
        },
        "invalidToken": {
            "invalidTokenHeader": "Votre lien a expiré",
            "invalidTokenHeaderPara": "Le lien sur lequel vous avez cliqué a expiré. Merci de saisir votre adresse e-mail pour recevoir un nouveau lien.",
            "resetPasswordHeader": "Réinitialisez votre mot de passe",
            "resetPasswordHeaderPara": "Veuillez entrer votre adresse courriel pour que nous puissions vous envoyez un lien pour réinitialiser votre mot de passe.",
            "emailPlaceholder": "Adresse courriel",
            "submit": "Soumettre",
            "invalidEmailError": "Votre adresse courriel n'est pas formatée correctement.",
            "emptyEmail": "Veuillez entrer une adresse électronique valide.",
            "unknownServerError": "Nous avons des difficultés à vous  envoyer un courriel pour réinitialiser votre mot de passe. Veuillez nous en excuser, nous nous efforçons de résoudre le problème. Veuillez attendre quelques minutes et cliquez de nouveau sur \"Soumettre\".",
            "noTokenSuccess": "Si un compte correspond à l'adresse que vous avez fournie, nous vous enverrons un courriel avec les instructions pour créer un nouveau mot de passe.",
            "invalidTokenSuccess": "Un nouveau lien a été envoyé à votre adresse courriel."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Votre mot de passe :",
                "policies": [
                    {
                    "policy": "doit être composé d'au moins 8 caractères"
                    },
                    {
                    "policy": "doit contenir au moins un caractère alphanumérique (A-Z) et un chiffre ou symbole"
                    },
                    {
                    "policy": "NE DOIT PAS contenir 4 caractères qui se suivent ou plus (e.g. AAAA ou 1234)"
                    },
                    {
                    "policy": "NE DOIT PAS contenir votre nom d'utilisateur, \"mstar\", \"MStar\", ou \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nouveau mot de passe",
            "emptyPassword": "Veuillez entrer un mot de passe valide.",
            "required": "Le mot de passe ne satisfait pas aux exigences.",
            "maxLength": "Le mot de passe excède le nombre de caractères maximum autorisé.",
            "passwordConfirmationPlaceholder": "Vérifier nouveau mot de passe",
            "passwordMatch": "Les mots de passe ne sont pas identiques.",
            "ie789Password": "Mot de passe",
            "ie789PasswordVerify": "Vérifiez mot de passe."
        },
        "login": {
            "ie789Email": "Adresse courriel",
            "emailPlaceholder": "Adresse courriel",
            "ie789Password": "Mot de passe",
            "passwordPlaceholder": "Mot de passe",
            "signin": "Ouvrir session",
            "invalidEmailError": "Votre adresse courriel n'est pas formatée correctement.",
            "emptyEmail": "Veuillez entrer une adresse courriel valide.",
            "authenticationError": "Les informations que vous avez fournies sont incorrectes.",
            "unknownServerError": "Il est impossible de traiter votre demande.",
            "maxlength": "Les informations que vous avez fournies sont incorrectes.<br>Veuillez corriger les champs concernés et réessayer.",
            "required": "Les informations que vous avez fournies sont incomplètes.<br>Veuillez remplir les deux champs concernés avant votre soumission.",
            "rememberMe": "Garder session ouverte",
            "forgotPassword": "Mot de passe oublié?",
            "notAMember": "Vous n'êtes pas membre?"
        },
        "enterMFA": {
            "mfaHeader": "OK excellent, entrez votre code ici.",
            "IdentificationPlaceholder": "Code d'identification",
            "badToken": "Ce code est inexact ou il a expiré.",
            "cancel": "Annuler",
            "go": "Aller",
            "newCode": "Avez-vous besoin d'un nouveau code?",
            "resend": "Renvoyez.",
            "emailMeHint": "Nous vous avons envoyé un code à votre adresse électronique ",
            "emailExpire": "Il expirera après 30 minutes.",
            "textMeHint": "Nous vous avons envoyé un code à votre numéro de téléphone ",
            "textExpire": "Il expirera après 30 minutes."
        },
        "receiveMFA": {
            "receiveMFAHeader": "Pour plus de sécurité, nous allons vous demander d’entrer un code de vérification.",
            "receiveMFAHeaderPara": "Attendez-vous à refaire la même chose tous les 30 jours sur chaque dispositif que vous utilisez pour accéder à ce produit.",
            "cancel": "Annuler",
            "emailMe": "Courriel SVP",
            "textMe": "Texto SVP",
            "emailTextInform": "Nous avons quelques difficultés avec la validation. Nous nous employons à les résoudre, toutes nos excuses. Vous pouvez demander que le code vous soit envoyé suivant une autre méthode, ou le redemander par courriel dans quelques minutes.",
            "emailInform": "Nous avons quelques difficultés avec la validation. Nous nous employons à les résoudre, toutes nos excuses. Veuillez nous redemander le code par courriel dans quelques minutes.",
            "emailHint": "Voulez-vous valider votre identité par le biais de votre adresse courriel ",
            "textHint": "ou votre numéro de téléphone ",
            "emailMeHint": "Nous vous enverrons un code de validation à votre adresse électronique ",
            "textMeHint": "Nous vous enverrons un code de validation à votre numéro de téléphone "
        },
        "forgotPwd": {
            "forgotPara": "Veuillez nous donner l'adresse courriel que vous avez inscrite et nous vous enverrons un courriel avec les instructions sur comment créer un nouveau mot de passe",
            "emailPlaceholder": "Adresse courriel",
            "invalidEmail": "Votre adresse courriel n'est pas formatée correctement.",
            "emptyEmail": "Veuillez entrer une adresse courriel valide.",
            "submit": "Soumettre",
            "cancel": "Annuler",
            "unknownServerError": "Nous avons des difficultés à vous  envoyer un courriel pour réinitialiser votre mot de passe. Veuillez nous en excuser, nous nous efforçons de résoudre le problème. Veuillez attendre quelques minutes et cliquez de nouveau sur \"Soumettre\".",
            "forgotPasswordSuccess": "Si un compte correspond à l'adresse que vous avez fournie, nous vous enverrons un courriel avec les instructions pour créer un nouveau mot de passe.",
            "returnToLogin": "Revenir page Ouvrir session"
        }
    },
    "de": {
        "resetPassword": {
            "header": "Passwort zurücksetzen",
            "subHeader": "Bitte geben Sie Ihr neues Passwort ein.",
            "submit": "Bestätigen",
            "authenticationError": "Die von Ihnen bereitgestellten Informationen sind fehlerhaft.",
            "unknownServerError": "Die Anfrage kann nicht bearbeitet werden.",
            "successMessage": "Ihr Passwort wurde erfolgreich aktualisiert.<br>Sie können diese Seite nun schließen und zu Ihrem Produkt-Login weitergehen."
        },
        "invalidToken": {
            "invalidTokenHeader": "Ihr Link ist abgelaufen",
            "invalidTokenHeaderPara": "Der Link, den Sie angeklickt haben, ist abgelaufen. Bitte geben Sie Ihre E-Mail-Adresse ein, um einen neuen Link zu erhalten.",
            "resetPasswordHeader": "Passwort zurücksetzen",
            "resetPasswordHeaderPara": "Bitte geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen dann einen Link zu, über den Sie Ihr Passwort zurücksetzen können.",
            "emailPlaceholder": "E-Mail-Adresse",
            "submit": "Bestätigen",
            "invalidEmailError": "Ihre E-Mail-Adresse ist falsch formatiert.",
            "emptyEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            "unknownServerError": "Wir können Ihnen keine E-Mail zur Zurücksetzung Ihres Passworts zusenden. Wir bedauern dies und bemühen uns aktiv darum, das Problem zu lösen. Bitte warten Sie einige Minuten und klicken Sie dann erneut auf \"Bestätigen\".",
            "noTokenSuccess": "Wenn Ihrer bereitgestellten Adresse ein Konto zugeordnet werden kann, senden wir Ihnen eine E-Mail mit Anweisungen zur Erstellung eines neuen Passworts zu.",
            "invalidTokenSuccess": "Es wurde ein neuer Link an Ihre E-Mail-Adresse versandt."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Ihr Passwort:",
                "policies": [
                    {
                        "policy": "Muss mindestens 8 lange Zeichen enthalten"
                    },
                    {
                        "policy": "Muss mindestens einen Buchstaben (A-Z) und eine Ziffer oder ein Symbol enthalten"
                    },
                    {
                        "policy": "Darf NICHT 4 oder mehr aufeinanderfolgende oder sich wiederholende Zeichen aufweisen (z.B. AAAA oder 1234)"
                    },
                    {
                        "policy": "Darf NICHT Ihren Nutzernamen, \"mstar\", \"MStar\", oder \"Morningstar\" enthalten"
                    }
                ]
            },
            "passwordPlaceholder": "Neues Passwort",
            "emptyPassword": "Bitte geben Sie ein gültiges Passwort ein.",
            "required": "Das Passwort entspricht nicht den Vorgaben.",
            "maxLength": "Das Passwort ist zu lang.",
            "passwordConfirmationPlaceholder": "Neues Passwort prüfen",
            "passwordMatch": "Die Passwörter stimmen nicht überein.",
            "ie789Password": "Passwort",
            "ie789PasswordVerify": "Passwort prüfen"
        }
    },
    "se": {
        "resetPassword": {
            "header": "Återställ lösenordet",
            "subHeader": "Ange ditt nya lösenord.",
            "submit": "Skicka",
            "authenticationError": "Den information du har lämnar är inkorrekt.",
            "unknownServerError": "Begäran går inte att behandla.",
            "successMessage": "Ditt lösenord har uppdaterats.<br>Nu kan du stänga denna sida och gå till inloggningen för din valda produkt."
        },
        "invalidToken": {
            "invalidTokenHeader": "Din länk har upphört att gälla",
            "invalidTokenHeaderPara": "Länken du har klickat på har upphört att gälla. Ange din e-postadress för att få en ny länk.",
            "resetPasswordHeader": "Återställ lösenordet",
            "resetPasswordHeaderPara": "Ange din e-postadress så att vi kan skicka en länk för återställning av ditt lösenord.",
            "emailPlaceholder": "E-postadress",
            "submit": "Skicka",
            "invalidEmailError": "Din e-postadress är felaktigt formaterad.",
            "emptyEmail": "Ange en giltig e-postadress.",
            "unknownServerError": "Det gick inte att skicka lösenord och återställa e-postadressen. Vi beklagar detta och vi arbetar på att lösa problemet. Vänta några minuter och klicka sedan på \"Skicka\" igen.",
            "noTokenSuccess": "Om ett konto stämmer överens med den adress du har lämnat kommer vi att skicka ett e-postmeddelande med anvisningar om hur man skapar ett nytt lösenord.",
            "invalidTokenSuccess": "En ny länk har skickats till din e-postadress."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Ditt lösenord:",
                "policies": [
                    {
                        "policy": "måste vara minst 8 tecken långt"
                    },
                    {
                        "policy": "Innehålla minst en bokstav (A-Z) och en siffra eller symbol"
                    },
                    {
                        "policy": "får INTE innehålla 4 eller flera tecken i följd eller upprepade tecken (t.ex. AAAA eller 1234)"
                    },
                    {
                        "policy": "får INTE innehålla användarnamn, \"mstar\", \"MStar\", eller \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nytt lösenord",
            "emptyPassword": "Ange ett giltigt lösenord.",
            "required": "Lösenordet uppfyller inte kraven.",
            "maxLength": "Lösenordet är för långt.",
            "passwordConfirmationPlaceholder": "Verifiera nytt lösenord",
            "passwordMatch": "Lösenorden är inte desamma.",
            "ie789Password": "Lösenord",
            "ie789PasswordVerify": "Verifiera lösenord"
        }
    },
    "it": {
        "resetPassword": {
            "header": "Reimposta la password",
            "subHeader": "Immetti la tua nuova password.",
            "submit": "Invia",
            "authenticationError": "Le informazioni che hai fornito non sono corrette.",
            "unknownServerError": "Non siamo in grado di elaborare la richiesta.",
            "successMessage": "La tua password è stata aggiornata.<br>Ora puoi chiudere questa pagina e procedere al login per il prodotto scelto."
        },
        "invalidToken": {
            "invalidTokenHeader": "Il tuo link è scaduto",
            "invalidTokenHeaderPara": "Il link che hai selezionato è scaduto. Inserisci il tuo indirizzo e-mail per ricevere un nuovo link.",
            "resetPasswordHeader": "Reimposta la password",
            "resetPasswordHeaderPara": "Inserisci il tuo indirizzo e-mail in modo da consentirci l’invio di un link per reimpostare la password.",
            "emailPlaceholder": "Indirizzo e-mail",
            "submit": "Invia",
            "invalidEmailError": "Il formato del tuo indirizzo e-mail non è corretto.",
            "emptyEmail": "Inserire un indirizzo e-mail valido.",
            "unknownServerError": "Stiamo incontrando delle difficoltà nell’invio dell’e-mail di reimpostazione della tua password. Siamo spiacenti, ma stiamo lavorando per risolvere il problema. Attendi qualche minuto e poi seleziona nuovamente \"Invia\".",
            "noTokenSuccess": "Se l’account corrisponde all’indirizzo che ci hai indicato, ti invieremo un’e-mail con le istruzioni per creare una nuova password.",
            "invalidTokenSuccess": "Abbiamo inviato un nuovo link al tuo indirizzo e-mail."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "La tua password:",
                "policies": [
                    {
                        "policy": "Deve contenere almeno 8 caratteri"
                    },
                    {
                        "policy": "Deve contenere almeno un carattere alfabetico (A-Z) e un numero o simbolo"
                    },
                    {
                        "policy": "NON deve contenere più di 3 caratteri progressivi o ripetuti (per es. AAAA o 1234)"
                    },
                    {
                        "policy": "NON deve contenere il tuo nome utente, \"mstar\", \"MStar\", o \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nuova password",
            "emptyPassword": "Inserire una password valida.",
            "required": "La password non rispetta i requisiti.",
            "maxLength": "La password ha superato la lunghezza massima consentita.",
            "passwordConfirmationPlaceholder": "Verifica nuova password",
            "passwordMatch": "Le password non corrispondono.",
            "ie789Password": "Password",
            "ie789PasswordVerify": "Verifica la password"
        }
    },
    "esc": {
        "resetPassword": {
            "header": "Restablecer Contraseña",
            "subHeader": "Introduzca su nueva contraseña.",
            "submit": "Enviar",
            "authenticationError": "La información que ha facilitado es incorrecta.",
            "unknownServerError": "No ha sido posible procesar la solicitud.",
            "successMessage": "Su contraseña se ha actualizado correctamente.<br>Ya puede cerrar esta página e ir al inicio de sesión del producto elegido."
        },
        "invalidToken": {
            "invalidTokenHeader": "Su enlace ha caducado",
            "invalidTokenHeaderPara": "El enlace en el que ha hecho clic ha caducado. Introduzca su dirección de correo electrónico para recibir un nuevo enlace.",
            "resetPasswordHeader": "Restablecer Contraseña",
            "resetPasswordHeaderPara": "Introduzca su dirección de correo electrónico para que podamos enviarse un enlace para restablecer su contraseña.",
            "emailPlaceholder": "Dirección de correo electrónico",
            "submit": "Enviar",
            "invalidEmailError": "El formato de su dirección de correo electrónico no es correcto.",
            "emptyEmail": "Introduzca una dirección de correo electrónico válida.",
            "unknownServerError": "Estamos teniendo problemas para enviarle su correo electrónico de restablecimiento de contraseña. Lo sentimos. Estamos trabajando para resolver el problema. Espere unos minutos y, a continuación, vuelva a hacer clic en \"Enviar\".",
            "noTokenSuccess": "Si una cuenta coincide con la dirección que ha indicado, le enviaremos un correo electrónico con instrucciones para crear una nueva contraseña.",
            "invalidTokenSuccess": "Le hemos enviado un nuevo enlace a su dirección de correo electrónico."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Su contraseña:",
                "policies": [
                    {
                        "policy": "Debe tener al menos ocho caracteres"
                    },
                    {
                        "policy": "Debe contener al menos un carácter alfanumérico (A-Z) y un número o símbolo"
                    },
                    {
                        "policy": "NO debe contener cuatro o más caracteres seguidos o repetidos (p. ej., AAAA o 1234)"
                    },
                    {
                        "policy": "NO de contener su nombre de usuario, \"mstar\", \"MStar\", ni \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nueva contraseña",
            "emptyPassword": "Introduzca una contraseña válida.",
            "required": "La contraseña no cumple los requisitos.",
            "maxLength": "La contraseña supera el número máximo de caracteres permitido.",
            "passwordConfirmationPlaceholder": "Verificar nueva contraseña",
            "passwordMatch": "Las contraseñas no coinciden.",
            "ie789Password": "Contraseña",
            "ie789PasswordVerify": "Verificar Contraseña"
        }
    },
    "nl": {
        "resetPassword": {
            "header": "Wachtwoord resetten",
            "subHeader": "Vul a.u.b. uw nieuwe wachtwoord in.",
            "submit": "Indienen",
            "authenticationError": "De informatie die u hebt gegeven, is onjuist.",
            "unknownServerError": "Het is niet mogelijk om uw aanvraag te verwerken.",
            "successMessage": "Het bijwerken van uw wachtwoord is geslaagd.<br>U kunt nu de pagina afsluiten en navigeren naar uw gekozen product login."
        },
        "invalidToken": {
            "invalidTokenHeader": "Uw link is niet meer geldig",
            "invalidTokenHeaderPara": "De link waarop u hebt geklikt is niet meer geldig. Geef uw e-mailadres op om een nieuwe link te ontvangen.",
            "resetPasswordHeader": "Wachtwoord resetten",
            "resetPasswordHeaderPara": "Geef uw e-mailadres op zodat we u een link kunnen sturen om uw wachtwoord te resetten.",
            "emailPlaceholder": "E-mailadres",
            "submit": "Indienen",
            "invalidEmailError": "De formattering van uw e-mailadres is onjuist.",
            "emptyEmail": "Geef een geldig e-mailadres op.",
            "unknownServerError": "Wij ondervinden problemen om u de e-mail te sturen waarmee u uw wachtwoord opnieuw kunt instellen. Dit spijt ons, maar wij werken aan een oplossing van dit probleem. Wacht een paar minuten en klik dan opnieuw op \"indienen\".",
            "noTokenSuccess": "Als er een account overeenkomt met het adres dat u opgeeft, sturen wij u een e-mail met instructies over hoe u een nieuw wachtwoord kunt aanmaken.",
            "invalidTokenSuccess": "Wij hebben een nieuwe link naar uw e-mailadres gestuurd."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Uw wachtwoord moet:",
                "policies": [
                    {
                        "policy": "Ten minste 8 tekens lang zijn"
                    },
                    {
                        "policy": "Ten minste één letter (A-Z) bevatten en één getal of symbool"
                    },
                    {
                        "policy": "Mag NIET 4 of meer achtereenvolgende of herhaalde tekens bevatten (bijv. AAAA of 1234)"
                    },
                    {
                        "policy": "Mag NIET uw gebruikersnaam, \"mstar\", \"MStar\", of \"Morningstar\" bevatten"
                    }
                ]
            },
            "passwordPlaceholder": "Nieuw wachtwoord",
            "emptyPassword": "Geef een geldig wachtwoord op.",
            "required": "Het wachtwoord voldoet niet aan de eisen.",
            "maxLength": "Wachtwoord is langer dan de maximaal toegestane lengte.",
            "passwordConfirmationPlaceholder": "Nieuw wachtwoord controleren",
            "passwordMatch": "Wachtwoorden komen niet overeen.",
            "ie789Password": "Wachtwoord",
            "ie789PasswordVerify": "Wachtwoord controleren"
        }
    },
    "nb": {
        "resetPassword": {
            "header": "Tilbakestille passord",
            "subHeader": "Du må oppgi det nye passordet.",
            "submit": "Send",
            "authenticationError": "Informasjonen du ga er ukorrekt.",
            "unknownServerError": "Kan ikke behandle forespørselen.",
            "successMessage": "Passordet ditt er oppdatert.<br>Du kan nå lukke denne siden og gå videre til påloggingssiden for det ønskede produktet."
        },
        "invalidToken": {
            "invalidTokenHeader": "Lenken er utgått",
            "invalidTokenHeaderPara": "Lenken du har klikket på har utgått. Du må oppgi e-postadressen igjen for å motta en ny lenke.",
            "resetPasswordHeader": "Tilbakestille passord",
            "resetPasswordHeaderPara": "Du må oppgi e-postadressen din slik at vi kan sende deg en lenke for tilbakestilling av passordet.",
            "emailPlaceholder": "E-postadresse",
            "submit": "Send",
            "invalidEmailError": "E-postadressen har feil format.",
            "emptyEmail": "Du må oppgi en gyldig e-postadresse.",
            "unknownServerError": "Vi har noen problemer med å sende deg e-postmeldingen om hvordan du skal tilbakestille passordet. Det beklager vi, men vi jobber med å løse problemet. Vent noen minutter og klikk på \"Submit\" (send) igjen.",
            "noTokenSuccess": "Hvis en konto tilsvarer adressen du oppga, vil vi sende deg en e-postmelding med anvisninger for hvordan du oppretter et nytt passord.",
            "invalidTokenSuccess": "En ny lenke er sendt til e-postadressen din."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Passordet må:",
                "policies": [
                    {
                        "policy": "Inneholde minst 8 tegn"
                    },
                    {
                        "policy": "Inneholde minst ett bokstavtegn (A-Z) og ett tall eller symbol"
                    },
                    {
                        "policy": "IKKE inneholde 4 eller flere fortløpende eller gjentatte tegn (f.eks. AAAA eller 1234)"
                    },
                    {
                        "policy": "IKKE inneholde brukernavnet ditt, \"mstar\", \"MStar\", eller \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nytt passord",
            "emptyPassword": "Du må oppgi et gyldig passord.",
            "required": "Passordet innfrir ikke kravene.",
            "maxLength": "Passordet har flere tegn enn det som er tillat.",
            "passwordConfirmationPlaceholder": "Bekreft nytt passord",
            "passwordMatch": "Passordene stemmer ikke.",
            "ie789Password": "Passord",
            "ie789PasswordVerify": "Bekreft passordet"
        }
    },
    "fi": {
        "resetPassword": {
            "header": "Vaihda salasana",
            "subHeader": "Anna uusi salasana.",
            "submit": "Lähetä",
            "authenticationError": "Antamasi tieto on väärä.",
            "unknownServerError": "Pyynnön käsittely ei onnistunut.",
            "successMessage": "Salasanan vaihto onnistui.<br>Voit nyt sulkea tämän sivun ja siirtyä haluamasi tuotteen sisäänkirjautumiseen."
        },
        "invalidToken": {
            "invalidTokenHeader": "Linkkisi on vanhentunut",
            "invalidTokenHeaderPara": "Linkki, jota napsautit, on vanhentunut. Anna sähköpostiosoitteesi saadaksesi uuden linkin.",
            "resetPasswordHeader": "Vaihda salasana",
            "resetPasswordHeaderPara": "Anna sähköpostiosoitteesi, jotta me voimme lähettää sinulla salasanan vaihtamislinkin.",
            "emailPlaceholder": "Sähköpostiosoite",
            "submit": "Lähetä",
            "invalidEmailError": "Sähköpostiosoitteesi on muotoiltu väärin.",
            "emptyEmail": "Anna kelvollinen sähköpostiosoite.",
            "unknownServerError": "Meillä on ongelmia salasanan vaihtamisen sähköpostiviestin lähettämisessä. Olemme pahoillamme, yritämme ratkaista ongelmaa. Odota muutama minuutti ja napsauta sitten uudestaan \"Lähetä\" painiketta.",
            "noTokenSuccess": "Jos antamallesi osoitteelle löytyy tili, niin lähetämme sinulla sähköpostitse ohjeet, miten luot uuden salasanan.",
            "invalidTokenSuccess": "Uusi linkki lähetettiin sähköpostiosoitteeseesi."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Salasanasi on:",
                "policies": [
                    {
                        "policy": "Oltava vähintään 8 merkkiä pitkä"
                    },
                    {
                        "policy": "Sisällettävä vähintään yksi kirjain (A-Z) ja yksi numero tai symboli"
                    },
                    {
                        "policy": "Se EI saa sisältää neljää tai useampaa peräkkäistä tai samaa merkkiä (esim. AAAA tai 1234)"
                    },
                    {
                        "policy": "Se EI saa sisältää käyttäjänimeäsi tai sanoja, \"mstar\", \"MStar\", tai \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Uusi salasana",
            "emptyPassword": "Anna kelvollinen salasana.",
            "required": "Salasana ei täytä vaatimuksia.",
            "maxLength": "Salasana ylittää sallitun enimmäispituuden.",
            "passwordConfirmationPlaceholder": "Vahvista uusi salasana",
            "passwordMatch": "Salasanat eivät täsmää.",
            "ie789Password": "Salasana",
            "ie789PasswordVerify": "Vahvista salasana"
        }
    },
    "da": {
        "resetPassword": {
            "header": "Nulstil adgangskode",
            "subHeader": "Indtast din nye adgangskode.",
            "submit": "Send",
            "authenticationError": "Du har angivet oplysninger, der ikke er korrekte.",
            "unknownServerError": "	Kunne ikke behandle henvendelse.",
            "successMessage": "Din adgangskode er ændret.<br>Du kan nu lukke denne side og gå til login for dit valgte produkt."
        },
        "invalidToken": {
            "invalidTokenHeader": "Dit link er udløbet",
            "invalidTokenHeaderPara": "Det link, du har klikket på, er udløbet. Indtast din e-mailadresse for at modtage et nyt link.",
            "resetPasswordHeader": "Nulstil adgangskode",
            "resetPasswordHeaderPara": "Indtast din e-mailadresse, så vi kan sende dig et link til at nulstille din adgangskode.",
            "emailPlaceholder": "E-mailadresse",
            "submit": "Send",
            "invalidEmailError": "Formatet på din e-mailadresse er forkert.",
            "emptyEmail": "Indtast en gyldig e-mailadresse.",
            "unknownServerError": "Vi har problemer med at sende en e-mail til dig om nulstilling af adgangskode. Vi beklager og arbejder på at løse problemet. Vent et par minutter og klik derefter på \"Send\" igen.",
            "noTokenSuccess": "Hvis der findes en konto med den adresse, du har oplyst, sender vi dig en e-mail med instruktioner til, hvordan du opretter en ny adgangskode.",
            "invalidTokenSuccess": "Der er sendt et nyt link til din e-mailadresse."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Din adgangskode skal/må:",
                "policies": [
                    {
                        "policy": "Bestå af mindst otte tegn"
                    },
                    {
                        "policy": "Indeholde mindst et bogstav (A-Z) og et tal eller symbol"
                    },
                    {
                        "policy": "IKKE indeholde fire eller flere fortløbende eller ens tegn (fx AAAA eller 1234)"
                    },
                    {
                        "policy": "IKKE indeholde dit brugernavn, \"mstar\", \"MStar\", eller \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Ny adgangskode",
            "emptyPassword": "Indtast en gyldig adgangskode.",
            "required": "Adgangskoden overholder ikke kravene.",
            "maxLength": "Adgangskode overskrider den tilladte længde.",
            "passwordConfirmationPlaceholder": "Bekræft ny adgangskode",
            "passwordMatch": "Adgangskoder stemmer ikke overens.",
            "ie789Password": "Adgangskode",
            "ie789PasswordVerify": "Bekræft adgangskode"
        }
    },
    "th": {
        "resetPassword": {
            "header": "รีเซ็ตรหัสผ่าน",
            "subHeader": "กรุณากรอกรหัสผ่านใหม่",
            "submit": "ส่ง",
            "authenticationError": "ข้อมูลที่ท่านให้มาไม่ถูกต้อง",
            "unknownServerError": "ไม่สามารถดำเนินการตามที่ร้องขอ",
            "successMessage": "รหัสผ่านของท่านได้รับการบันทึกเรียบร้อยแล้ว<br>ท่านสามารถปิดหน้านี้และเข้าไปสู่ระบบสินค้าที่ท่านได้เลือกไว้"
        },
        "invalidToken": {
            "invalidTokenHeader": "ลิงก์ของท่านหมดอายุแล้ว",
            "invalidTokenHeaderPara": "ลิงก์ที่ท่านคลิกนั้นหมดอายุแล้ว โปรดป้อนที่อยู่อีเมลเพื่อรับลิงก์ใหม่",
            "resetPasswordHeader": "รีเซ็ตรหัสผ่าน",
            "resetPasswordHeaderPara": "โปรดป้อนที่อยู่อีเมลของท่าน เพื่อให้เราสามารถส่งลิงก์เพื่อรีเซ็ตรหัสผ่านให้ท่านได้",
            "emailPlaceholder": "ที่อยู่อีเมล",
            "submit": "ส่ง",
            "invalidEmailError": "ที่อยู่อีเมลของท่านมีรูปแบบไม่ถูกต้อง",
            "emptyEmail": "โปรดป้อนที่อยู่อีเมลที่ถูกต้อง.",
            "unknownServerError": "เราพบปัญหาในการส่งอีเมลรีเซ็ตรหัสผ่านให้ท่าน ขออภัยในสิ่งที่เกิดขึ้น แต่เรากำลังพยายามดำเนินการเพื่อแก้ไขปัญหา โปรดรอสักครู่ จากนั้นคลิก \"ส่ง\" อีกครั้ง",
            "noTokenSuccess": "หากมีบัญชีที่ตรงกับที่อยู่อีเมลที่ท่านให้มา เราจะส่งอีเมลที่มีคำแนะนำวิธีการสร้างรหัสผ่านใหม่ให้แก่ท่าน",
            "invalidTokenSuccess": "ลิงก์ใหม่ถูกส่งไปยังที่อยู่อีเมลของท่านแล้ว"
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "รหัสผ่านของท่านจะต้อง:",
                "policies": [
                    {
                        "policy": "มีความยาวอย่างน้อย 8 ตัวอักษร"
                    },
                    {
                        "policy": "ประกอบด้วยอักขระ (A-Z) อย่างน้อยหนึ่งตัว และตัวเลขหรือสัญลักษณ์อย่างน้อยหนึ่งตัว"
                    },
                    {
                        "policy": "ไม่ประกอบด้วยตัวอักขระเป็นลำดับหรือซ้ำกัน 4 ตัวขึ้นไป (เช่น AAAA หรือ 1234)"
                    },
                    {
                        "policy": "ไม่ประกอบด้วยชื่อผู้ใช้, \"mstar\", \"MStar\", หรือ \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "รหัสผ่านใหม่",
            "emptyPassword": "โปรดป้อนรหัสผ่านที่ถูกต้อง",
            "required": "รหัสผ่านไม่ตรงกับข้อกำหนด",
            "maxLength": "ความยาวของรหัสผ่านเกินความยาวที่อนุญาต",
            "passwordConfirmationPlaceholder": "ยืนยันรหัสผ่านใหม่",
            "passwordMatch": "รหัสผ่านไม่ตรงกัน",
            "ie789Password": "รหัสผ่าน",
            "ie789PasswordVerify": "ยืนยันรหัสผ่าน"
        }
    },
    "es": {
        "resetPassword": {
            "header": "Restaurar contraseña",
            "subHeader": "Por favor escriba su nueva contraseña",
            "submit": "Enviar",
            "authenticationError": "La información proporcionada es incorrecta.",
            "unknownServerError": "No fue posible procesar su petición.",
            "successMessage": "Su contraseña ha sido actualizada correctamente.<br>Ahora puede cerrar esta página y navegar en su producto elegido."
        },
        "invalidToken": {
            "invalidTokenHeader": "El link ha expirado",
            "invalidTokenHeaderPara": "El link ha expirado. Por favor indique su correo electrónico para recibir un nuevo link.",
            "resetPasswordHeader": "Restaurar contraseña",
            "resetPasswordHeaderPara": "Por favor indique su dirección de correo electrónico para que podamos enviarle el link para cambio de contraseña.",
            "emailPlaceholder": "Dirección de correo electrónico",
            "submit": "Enviar",
            "invalidEmailError": "Su cuenta de correo electrónico no está especificada con el formato adecuado.",
            "emptyEmail": "Por favor indique una dirección de correo electrónico válida.",
            "unknownServerError": "Estamos experimentado problemas al enviar el correo electrónico para restaurar contraseñas. Estamos trabajando en resolver el problema. Por favor espere unos minutos y vuelva a intentar.",
            "noTokenSuccess": "Si una cuenta coincide con la dirección que nos suministró, le enviaremos un correo electrónico con las instrucciones de cómo crear una nueva contraseña.",
            "invalidTokenSuccess": "Un nuevo link ha sido enviado a su dirección de correo electrónico."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Su contraseña debe:",
                "policies": [
                    {
                        "policy": "Contener al menos 8 caracteres"
                    },
                    {
                        "policy": "Contener al menos una letra (a-z) y un número o símbolo"
                    },
                    {
                        "policy": "No debe contener más de 4 caracteres en secuencia o repetidos (ejemplo: AAAA o 1234)"
                    },
                    {
                        "policy": "No debe contener su nombre de usuario, \"mstar\", \"MStar\", o \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nueva contraseña",
            "emptyPassword": "Introduzca una contraseña válida.",
            "required": "La contraseña no cumple con los requisitos mínimos.",
            "maxLength": "La contraseña supera el número máximo de caracteres permitido.",
            "passwordConfirmationPlaceholder": "Verificar la nueva contraseña",
            "passwordMatch": "La contraseña no corresponde.",
            "ie789Password": "Contraseña",
            "ie789PasswordVerify": "Verificar contraseña"
        }
    },
    "fr": {
        "resetPassword": {
            "header": "Réinitialiser le mot de passe",
            "subHeader": "Veuillez entrer votre nouveau mot de passe.",
            "submit": "Soumettre",
            "authenticationError": "Les informations que vous avez fournies ne sont pas correctes.",
            "unknownServerError": "Traitement de la requête impossible.",
            "successMessage": "Votre mot de passe a été mis à jour avec succès.<br>Vous pouvez fermer cette page et naviguer vers la connexion pour le produit choisi."
        },
        "invalidToken": {
            "invalidTokenHeader": "Votre lien a expiré",
            "invalidTokenHeaderPara": "Le lien sur lequel vous avez cliqué n’est plus actif. Insérez votre adresse électronique afin de recevoir un nouveau lien.",
            "resetPasswordHeader": "Réinitialiser le mot de passe",
            "resetPasswordHeaderPara": "Veuillez entrer votre adresse électronique afin que nous puissions vous envoyer un lien pour réinitialiser votre mot de passe.",
            "emailPlaceholder": "Adresse électronique",
            "submit": "Soumettre",
            "invalidEmailError": "Votre adresse électronique n’est pas au bon format.",
            "emptyEmail": "Veuillez entrer une adresse électronique valide.",
            "unknownServerError": "Nous rencontrons des difficultés pour vous envoyer un courriel pour réinitialiser votre mot de passe. Nous sommes désolés, nous cherchons une solution au problème. Veuillez attendre quelques minutes et cliquez à nouveau sur \"Soumettre\".",
            "noTokenSuccess": "Si un compte correspond à l’adresse communiquée, nous vous enverrons un courriel avec les instructions pour créer un nouveau mot de passe.",
            "invalidTokenSuccess": "Un nouveau lien a été envoyé à votre adresse électronique."
        },
        "commonPassword": {
            "passwordRequirements": {
                "header": "Votre mot de passe doit:",
                "policies": [
                    {
                        "policy": "Contenir au moins 8 caractères"
                    },
                    {
                        "policy": "Contenir au moins une lettre (A-Z) et un chiffre ou symbole"
                    },
                    {
                        "policy": "NE PAS contenir 4 caractères (ou plus) séquentiels ou répétés (p. ex. AAAA ou 1234)"
                    },
                    {
                        "policy": "NE PAS contenir votre identifiant, \"mstar\", \"MStar\", ou \"Morningstar\""
                    }
                ]
            },
            "passwordPlaceholder": "Nouveau mot de passe",
            "emptyPassword": "Veuillez entrer une adresse électronique valide.",
            "required": "Le mot de passe ne correspond pas aux critères.",
            "maxLength": "Le mot de passe dépasse la longueur autorisée.",
            "passwordConfirmationPlaceholder": "Vérifier le nouveau mot de passe",
            "passwordMatch": "Les mots de passe ne correspondent pas.",
            "ie789Password": "Mot de passe",
            "ie789PasswordVerify": "Vérifier le mot de passe"
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/json/TemplatesText.json
// module id = 18
// module chunks = 0